import { reportActionConstants } from 'home/Reports/actions/reports.constants';
import _ from 'lodash';

const initialState = {
  allSensors: [],
};

export const reportHealthSummaryReducer = (state = initialState, action) => {
  switch (action.type) {
    case reportActionConstants.INIT_REPORTS: {
      const resetState = {
        allSensors: [],
      };
      return {
        ...resetState
      };
    }
    case reportActionConstants.ADD_ALL_SENSORS: {
      return {
        ...state,
        allSensors: action.keepPrevSensors ? _.uniqBy([
          ...state.allSensors, ...action.sensors
        ], 'serial_number') : [...action.sensors]
      };
    }
    case reportActionConstants.REMOVE_ALL_SENSORS: {
      return {
        ...state,
        allSensors: []
      };
    }
    default:
      return state;
  }
};
